<div class="toolbar">
  <button matButton="text" class="toolbarButton" [disabled]="isBusy() || !unitsSelected()" (click)="copySelectedUnits()">
    <span>
      <mat-icon class="size-16">content_copy</mat-icon>
      <label class="buttonLabel">Copy</label>
    </span>
  </button>
  <button matButton="text" class="toolbarButton" [disabled]="isBusy() || !unitsSelected()" (click)="deleteSelectedUnits()">
    <span>
      <mat-icon class="size-16">delete</mat-icon>
      <label class="buttonLabel">Delete</label>
    </span>
  </button>
  <button matButton="text" class="toolbarButton" [disabled]="!canMoveUp()" (click)="moveSelectedUnitsUp()">
    <span>
      <mat-icon class="size-16">expand_less</mat-icon>
      <label class="buttonLabel">Move Up</label>
    </span>
  </button>
  <button matButton="text" class="toolbarButton" [disabled]="!canMoveDown()" (click)="moveSelectedUnitsDown()">
    <span>
      <mat-icon class="size-16">expand_more</mat-icon>
      <label class="buttonLabel">Move Down</label>
    </span>
  </button>
  <button matButton="text" class="toolbarButton" [disabled]="isBusy() || selectionSize() < 2" (click)="openMassUpdateDialog()">
    <span>
      <mat-icon class="size-16">done_all</mat-icon>
      <label class="buttonLabel">Mass Update</label>
    </span>
  </button>
  <button matButton="text" class="toolbarButton" [disabled]="isBusy()" (click)="chooseColumns()">
    <span>
      <mat-icon class="size-16">edit</mat-icon>
      <label class="buttonLabel">Edit Columns</label>
    </span>
  </button>
  <span class="spacer"></span>
  <button matButton="text" class="toolbarButton" [disabled]="isBusy() || !unitsSelected()" (click)="createSchedule()">
    <span>
      <mat-icon class="size-16">add</mat-icon>
      <label class="buttonLabel">Create Schedule</label>
    </span>
  </button>
</div>
@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
<div class="content">
  <div class="inputRow">
    <span class="spacer"></span>
    @if (isBusy()) {
      <mat-progress-spinner mode="indeterminate" class="spinner" diameter="32"></mat-progress-spinner>
    }
    <mat-paginator [pageSizeOptions]="[25, 50, 100]" [pageSize]="25" [showFirstLastButtons]=true></mat-paginator>
  </div>
  <table mat-table [dataSource]="datasource" class="paginatedTable bordered-table" #unitListTable cdkDropList
    [cdkDropListData]="datasource.data" (cdkDropListDropped)="onListDrop($event)">
    <ng-container matColumnDef="select">
      <th class="buttonCell" mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? masterToggle() : null" [disabled]="isBusy()"
          [checked]="selection() && selection().hasValue() && isAllSelected()"
          [indeterminate]="selection() && selection().hasValue() && !isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row" class="col-xs">
        <mat-checkbox (click)="$event.stopPropagation()" [disabled]="isBusy()"
          (change)="$event ? toggleRowSelection(row) : null" [checked]="selection().isSelected(row)">
        </mat-checkbox>
      </td>
    </ng-container>
    <ng-container matColumnDef="edit">
      <th class="buttonCell" mat-header-cell *matHeaderCellDef>Edit</th>
      <td mat-cell *matCellDef="let record" class="col-xs">
        <button matButton="text" (click)="editUnit(record)" [disabled]="isBusy()">
          <mat-icon class="size-16">edit</mat-icon>
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="sequence">
      <th mat-header-cell *matHeaderCellDef>Sequence</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.sequence }}</td>
    </ng-container>
    <ng-container matColumnDef="modelCode">
      <th mat-header-cell *matHeaderCellDef>Model</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.modelCode }}</td>
    </ng-container>
    <ng-container matColumnDef="sizeCode">
      <th mat-header-cell *matHeaderCellDef>Size</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.sizeCode }}</td>
    </ng-container>
    <ng-container matColumnDef="modelSize">
      <th mat-header-cell *matHeaderCellDef>Model/Size</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.modelCode + record.sizeCode }}</td>
    </ng-container>
    <ng-container matColumnDef="airflow">
      <th mat-header-cell *matHeaderCellDef>Airflow</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.response?.Airflow }}</td>
    </ng-container>
    <ng-container matColumnDef="externalStaticPressure">
      <th mat-header-cell *matHeaderCellDef>ESP</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.request?.ExternalStaticPressure }}</td>
    </ng-container>
    <ng-container matColumnDef="coilRows">
      <th mat-header-cell *matHeaderCellDef>Coil Rows</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.coilRowCode }}</td>
    </ng-container>
    <ng-container matColumnDef="primaryCoilCircuitCount">
      <th mat-header-cell *matHeaderCellDef>Primary Coil Circuits</th>
      <td mat-cell *matCellDef="let record"
        class="col-sm">{{ record.response?.PrimaryCoilResponse?.NumberOfCircuits }}
      </td>
    </ng-container>
    <ng-container matColumnDef="primaryTotalCapacity">
      <th mat-header-cell *matHeaderCellDef>Primary Total Capacity</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.response?.PrimaryCoilResponse?.TotalCapacity }}
      </td>
    </ng-container>
    <ng-container matColumnDef="primarySensibleCapacity">
      <th mat-header-cell *matHeaderCellDef>Primary Sensible Capacity</th>
      <td mat-cell *matCellDef="let record"
        class="col-sm">{{ record.response?.PrimaryCoilResponse?.SensibleCapacity }}
      </td>
    </ng-container>
    <ng-container matColumnDef="primaryEnteringDryBulb">
      <th mat-header-cell *matHeaderCellDef>Primary Entering Dry Bulb</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.request?.PrimaryCoilRequest?.EnteringDryBulb }}
      </td>
    </ng-container>
    <ng-container matColumnDef="primaryLeavingDryBulb">
      <th mat-header-cell *matHeaderCellDef>Primary Leaving Dry Bulb</th>
      <td mat-cell *matCellDef="let record"
        class="col-sm">{{ record.response?.PrimaryCoilResponse?.LeavingDryBulbTemperature }}
      </td>
    </ng-container>
    <ng-container matColumnDef="primaryEnteringWetBulb">
      <th mat-header-cell *matHeaderCellDef>Primary Entering Wet Bulb</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.request?.PrimaryCoilRequest?.EnteringWetBulb }}
      </td>
    </ng-container>
    <ng-container matColumnDef="primaryLeavingWetBulb">
      <th mat-header-cell *matHeaderCellDef>Primary Leaving Wet Bulb</th>
      <td mat-cell *matCellDef="let record"
        class="col-sm">{{ record.response?.PrimaryCoilResponse?.LeavingWetBulbTemperature }}
      </td>
    </ng-container>
    <ng-container matColumnDef="primaryEnteringFluidTemperature">
      <th mat-header-cell *matHeaderCellDef>Primary Entering Fluid Temp</th>
      <td mat-cell *matCellDef="let record"
        class="col-sm">{{ record.request?.PrimaryCoilRequest?.EnteringFluidTemperature }}
      </td>
    </ng-container>
    <ng-container matColumnDef="primaryLeavingFluidTemperature">
      <th mat-header-cell *matHeaderCellDef>Primary Leaving Fluid Temp</th>
      <td mat-cell *matCellDef="let record"
        class="col-sm">{{ record.response?.PrimaryCoilResponse?.LeavingFluidTemperature }}
      </td>
    </ng-container>
    <ng-container matColumnDef="primaryFluidFlowRate">
      <th mat-header-cell *matHeaderCellDef>Primary Fluid Flow Rate</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.response?.PrimaryCoilResponse?.FluidFlowRate }}
      </td>
    </ng-container>
    <ng-container matColumnDef="primaryFluidPressureDrop">
      <th mat-header-cell *matHeaderCellDef>Primary Fluid Pressure Drop</th>
      <td mat-cell *matCellDef="let record"
        class="col-sm">{{ record.response?.PrimaryCoilResponse?.FluidPressureDrop }}
      </td>
    </ng-container>
    <ng-container matColumnDef="secondaryCoilCircuitCount">
      <th mat-header-cell *matHeaderCellDef>Secondary Coil Circuits</th>
      <td mat-cell *matCellDef="let record"
        class="col-sm">{{ record.response?.SecondaryCoilResponse?.NumberOfCircuits }}
      </td>
    </ng-container>
    <ng-container matColumnDef="secondaryTotalCapacity">
      <th mat-header-cell *matHeaderCellDef>Secondary Total Capacity</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.response?.SecondaryCoilResponse?.TotalCapacity }}
      </td>
    </ng-container>
    <ng-container matColumnDef="secondaryEnteringDryBulb">
      <th mat-header-cell *matHeaderCellDef>Secondary Entering Dry Bulb</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.request?.SecondaryCoilRequest?.EnteringDryBulb }}
      </td>
    </ng-container>
    <ng-container matColumnDef="secondaryLeavingDryBulb">
      <th mat-header-cell *matHeaderCellDef>Secondary Leaving Dry Bulb</th>
      <td mat-cell *matCellDef="let record"
        class="col-sm">{{ record.response?.SecondaryCoilResponse?.LeavingDryBulbTemperature }}
      </td>
    </ng-container>
    <ng-container matColumnDef="secondaryEnteringFluidTemperature">
      <th mat-header-cell *matHeaderCellDef>Secondary Entering Fluid Temp</th>
      <td mat-cell *matCellDef="let record"
        class="col-sm">{{ record.request?.SecondaryCoilRequest?.EnteringFluidTemperature }}
      </td>
    </ng-container>
    <ng-container matColumnDef="secondaryLeavingFluidTemperature">
      <th mat-header-cell *matHeaderCellDef>Secondary Leaving Fluid Temp</th>
      <td mat-cell *matCellDef="let record"
        class="col-sm">{{ record.response?.SecondaryCoilResponse?.LeavingFluidTemperature }}
      </td>
    </ng-container>
    <ng-container matColumnDef="secondaryFluidFlowRate">
      <th mat-header-cell *matHeaderCellDef>Secondary Fluid Flow Rate</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.response?.SecondaryCoilResponse?.FluidFlowRate }}
      </td>
    </ng-container>
    <ng-container matColumnDef="secondaryFluidPressureDrop">
      <th mat-header-cell *matHeaderCellDef>Secondary Fluid Pressure Drop</th>
      <td mat-cell *matCellDef="let record"
        class="col-sm">{{ record.response?.SecondaryCoilResponse?.FluidPressureDrop }}
      </td>
    </ng-container>
    <ng-container matColumnDef="electricHeatVoltage">
      <th mat-header-cell *matHeaderCellDef>E-Heat Voltage</th>
      <td mat-cell *matCellDef="let record"
        class="col-sm">{{ record.request?.ElectricHeatRequest?.ElectricHeatVoltage }}
      </td>
    </ng-container>
    <ng-container matColumnDef="electricHeatKilowatts">
      <th mat-header-cell *matHeaderCellDef>E-Heat KW</th>
      <td mat-cell *matCellDef="let record"
        class="col-sm">{{ record.request?.ElectricHeatRequest?.ElectricHeatKilowatts }}
      </td>
    </ng-container>
    <ng-container matColumnDef="electricHeatDryBulb">
      <th mat-header-cell *matHeaderCellDef>E-Heat Dry Bulb</th>
      <td mat-cell *matCellDef="let record"
        class="col-sm">{{ record.response?.ElectricHeatResponse?.LeavingDryBulbTemperature }}
      </td>
    </ng-container>
    <ng-container matColumnDef="fanSpeed">
      <th mat-header-cell *matHeaderCellDef>Fan Speed</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.request?.FanSpeed }}</td>
    </ng-container>
    <ng-container matColumnDef="motorType">
      <th mat-header-cell *matHeaderCellDef>Motor Type</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.request?.MotorType }}</td>
    </ng-container>
    <ng-container matColumnDef="voltage">
      <th mat-header-cell *matHeaderCellDef>Motor VPH</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.request?.MotorConfiguration }}</td>
    </ng-container>
    <ng-container matColumnDef="power">
      <th mat-header-cell *matHeaderCellDef>Power</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.response?.CircuitResponse?.OutputPower }}</td>
    </ng-container>
    <ng-container matColumnDef="fullLoadAmps">
      <th mat-header-cell *matHeaderCellDef>Motor FLA</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.response?.CircuitResponse?.FullLoadAmps }}</td>
    </ng-container>
    <ng-container matColumnDef="minimumCircuitAmps">
      <th mat-header-cell *matHeaderCellDef>Min Circuit Amps</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.response?.CircuitResponse?.MinimumCircuitAmps }}
      </td>
    </ng-container>
    <ng-container matColumnDef="brakingHorsepower">
      <th mat-header-cell *matHeaderCellDef>BHP</th>
      <td mat-cell *matCellDef="let record"
        class="col-sm">{{ record.response?.PrimaryDrivePackage?.BrakingHorsepower }}
      </td>
    </ng-container>
    <ng-container matColumnDef="primaryDrivePackageRpm">
      <th mat-header-cell *matHeaderCellDef>Primary Drive Package RPM</th>
      <td mat-cell *matCellDef="let record"
        class="col-sm">{{ record.response?.PrimaryDrivePackage?.RevolutionsPerMinute }}
      </td>
    </ng-container>
    <ng-container matColumnDef="primaryDrivePackageHp">
      <th mat-header-cell *matHeaderCellDef>Primary Drive Package HP</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.response?.PrimaryDrivePackage?.Horsepower }}</td>
    </ng-container>
    <ng-container matColumnDef="primaryDrivePackageCode">
      <th mat-header-cell *matHeaderCellDef>Primary Drive Package Code</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.response?.PrimaryDrivePackage?.DriveCode }}</td>
    </ng-container>
    <ng-container matColumnDef="primaryDrivePackageTurns">
      <th mat-header-cell *matHeaderCellDef>Primary Drive Package Turns</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.response?.PrimaryDrivePackage?.NumberOfTurns }}
      </td>
    </ng-container>
    <ng-container matColumnDef="secondaryDrivePackageRpm">
      <th mat-header-cell *matHeaderCellDef>Secondary Drive Package RPM</th>
      <td mat-cell *matCellDef="let record"
        class="col-sm">{{ record.response?.SecondaryDrivePackage?.RevolutionsPerMinute }}
      </td>
    </ng-container>
    <ng-container matColumnDef="secondaryDrivePackageHp">
      <th mat-header-cell *matHeaderCellDef>Secondary Drive Package HP</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.response?.SecondaryDrivePackage?.Horsepower }}</td>
    </ng-container>
    <ng-container matColumnDef="secondaryDrivePackageCode">
      <th mat-header-cell *matHeaderCellDef>Secondary Drive Package Code</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.response?.SecondaryDrivePackage?.DriveCode }}</td>
    </ng-container>
    <ng-container matColumnDef="secondaryDrivePackageTurns">
      <th mat-header-cell *matHeaderCellDef>Secondary Drive Package Turns</th>
      <td mat-cell *matCellDef="let record" class="col-sm">{{ record.response?.SecondaryDrivePackage?.NumberOfTurns }}
      </td>
    </ng-container>
    <ng-container matColumnDef="notes">
      <th mat-header-cell *matHeaderCellDef>Notes</th>
      <td mat-cell *matCellDef="let record" class="col-md" matTooltipClass="costFactorInfo"
        [matTooltip]="record.notes">{{ record.notes }}
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
    <tr class="clickableRow" [class.selectedRow]="selection().isSelected(row)" mat-row
      [class.errorUnit]="row.response?.Airflow === 0"
      *matRowDef="let row; columns: displayedColumns();" (click)="toggleRowSelection(row)" cdkDrag
    cdkDragLockAxis="y"></tr>
  </table>
</div>
